export function isAtLeastOneHour(seconds: number): boolean {
  return !!new Date(seconds * 1000).getUTCHours()
}
